'use client';

import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import { shouldShowTaxNote } from '@/lib/tax';
import styles from './TaxNote.module.scss';

interface TaxNoteProps {
  countryCode: string;
  context: 'cart' | 'drawer' | 'checkout' | 'confirmation';
  className?: string;
}

/**
 * Renders "Sales tax calculated at checkout" for US/CA in cart/drawer contexts.
 * Returns null for all other countries or non-cart contexts.
 */
export const TaxNote = ({ countryCode, context, className }: TaxNoteProps) => {
  const t = useTranslations('price');

  if (!shouldShowTaxNote(countryCode, context)) return null;

  return <span className={clsx(styles.note, className)}>{t('note.calculatedAtCheckout')}</span>;
};
